class BlocklistController {
    constructor(OrderAPI, NoLoginPayAPI,$state,$filter, userInfo,$rootScope,$scope, $stateParams,message,$timeout) {
        "ngInject";
        this.$state=$state;
        this.$rootScope=$rootScope;
        this.$scope=$scope;
        this.OrderAPI=OrderAPI;
        this.message = message;
        this.$stateParams=$stateParams;
        this.$timeout=$timeout;
        this.order={};
        this.userInfo=userInfo;
        this.NoLoginPayAPI=NoLoginPayAPI;
        this.isLogined=this.appUser && this.appUser.id
        this.tranlsteFilter=$filter('translate');
        let self=this;
        self.wechatPay=function(callback){
            let payment = {
                'pay_type': 'pubnumber'
            };
            let api='';
            if(self.isLogined){
                api=this.OrderAPI.one(self.$stateParams.id).post('pay', payment)
            }else{
                //未登录pc端用微信扫码购买
                payment.order_id=self.$stateParams.id;
                api=this.NoLoginPayAPI.one('weixin').post('qrcode', payment)
            };
            api.then(
                (data) => {
                    self.order = data.order;
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                            "appId":data.js_json.appId||'',     //公众号名称，由商户传入
                            "timeStamp":data.js_json.timeStamp||'',         //时间戳，自1970年以来的秒数
                            "nonceStr":data.js_json.nonceStr||'', //随机串
                            "package":data.js_json.package||'',
                            "signType":data.js_json.signType||'',         //微信签名方式：
                            "paySign":data.js_json.paySign||'' //微信签名
                        },
                        function(res){
                            if(res.err_msg == "get_brand_wcpay_request:ok") {
                                callback({status:'success'})
                            }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
                                callback({status:'cancel'})
                            }else{
                                callback({status:'fail'})
                            }

                        }
                    );

                },
                (response) => {
                    self.loading = false;
                    self.message.error(response.data);
                }
            );


        };
        self.onBridgeReady=function(){
            self.wechatPay(function (res) {
                if(res.status==='success'){
                    self.checkOrderStatus();
                }else if(res.status==='cancel'){
                    self.buyFailed(self.tranlsteFilter('page-payment-text002'));
                }else{
                    self.buyFailed(self.tranlsteFilter('page-payment-text003'));
                }
            })
        };
    }
    checkOrderStatus() {
        let self = this;
        if(!self.isLogined){
            this.NoLoginPayAPI.one('order').one(self.order.order_id).get().then(
                (order) => {
                    if (order && order.status == 2) {
                        self.order = order;
                        self.buySucceed();

                    } else {
                        self.message.error(response.data);
                    }
                },
                (response) => {
                    self.message.error(response.data);
                }
            );
        }else{
            this.OrderAPI.one(self.$stateParams.id).get().then(
                (order) => {
                    self.order = order;
                    if (order.status == 2) {
                        self.buySucceed();
                    } else {
                        self.$timeout(() => {
                            self.checkOrderStatus();
                        }, 3000);
                    }
                },
                (response) => {
                    self.message.error(response.data);
                }
            );
        }

    }

    buySucceed() {
        let self = this;
        self.message.success(self.tranlsteFilter('page-payment-text001'));
        self.$timeout(() => {
            if (self.order.order_article) {
                self.$state.go('app.page.original.articleReproduction', {reproduction: self.order.order_article.yuanben_id});
            } else {
                self.$state.go('app.page.original.imageReproduction', {reproduction: self.order.order_image.yuanben_id});
            }
        }, 1000);
    }
    buyFailed(typestr) {
        let self = this;
        self.message.error(typestr);
        self.$timeout(() => {
            if (self.order.order_article) {
                self.$state.go('app.page.original.article', {id: self.order.order_article.article.yuanben_id});
            } else {
                self.$state.go('app.page.original.image', {id: self.order.order_image.image.yuanben_id});
            }
        }, 1000);
    }
    $onInit(){
        let self=this;
        if (typeof WeixinJSBridge == "undefined"){
            if(typeof document.addEventListener =='function'){
                document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false);
            }
        }else{
            self.onBridgeReady();
        }
    }

}

export default BlocklistController;



// WEBPACK FOOTER //
// ./src/app/components/page/payment/payment.controller.js